import type { RunwayPeriod } from '@/api/types'
import { shortDate } from '@/lib/period'

/** "Live", or "As of Aug 14" for any other view. */
export function liveText(period: RunwayPeriod): string {
  return period.is_live ? 'Live' : `As of ${shortDate(period.as_of)}`
}

/** One-line summary of the collapsed panel: "Q4 2026 · Live", "Q3 2026 · as of Aug 14". */
export function filterSummary(period: RunwayPeriod): string {
  return `${period.label} · ${period.is_live ? 'Live' : `as of ${shortDate(period.as_of)}`}`
}

/** "Q3" for a quarter, else the full label ("FY 2026", "Jan + Aug 2026"). */
export function periodShort(period: RunwayPeriod): string {
  return period.kind === 'quarter' ? (period.label.split(' ')[0] ?? period.label) : period.label
}

/** "quarter", "year" or "period". */
export function periodNoun(period: RunwayPeriod): string {
  return period.kind === 'quarter' ? 'quarter' : period.kind === 'year' ? 'year' : 'period'
}

/** The actual-to-date KPI label: "QTD Actual", "YTD Actual", "Actual to Date", or "Q3 Actual" once final. */
export function actualLabel(period: RunwayPeriod): string {
  if (period.complete) return `${periodShort(period)} Actual`
  if (period.kind === 'quarter') return 'QTD Actual'
  if (period.kind === 'year') return 'YTD Actual'
  return 'Actual to Date'
}

/** "2026-Q3" → "Q3 2026". */
export function quarterIdLabel(id: string): string {
  const m = /^(\d{4})-Q([1-4])$/.exec(id)
  return m ? `Q${m[2]} ${m[1]}` : id
}

/** Why the pace chart is missing for months that are not adjacent (the original's note). */
export const NON_CONTIGUOUS_NOTE =
  'The pacing chart needs adjoining months (a quarter, a full year, or months next to each other) — pick one of those to see it. Everything else on this page works for any combination.'
